import { takeLatest, call, put } from 'redux-saga/effects';
import { removeItem, setItem } from 'utils/localStorage';
import request from 'utils/request';
import {
  fetchAuthenticatedUserSuccess,
  fetchCommonDataSuccess,
  logoutSuccess,
} from './actions';
import {
  CHANGE_LOCALE_SAGA,
  FETCH_AUTHENTICATED_USER_REQUEST,
  FETCH_COMMON_DATA_REQUEST,
  LOGOUT_REQUEST,
  UPDATE_AUTHENTICATED_USER,
} from './constants';
import { ENDPOINTS } from '../../constants';
import { enqueueSnackbar } from '../Notifier/actions';
import { setLocale } from '../LanguageProvider/actions';
import { HTTP_METHODS } from '../../constants/http';

export function* fetchUser() {
  try {
    const user = yield call(request, {
      url: '/auth/me',
      method: 'get',
    });
    yield put(fetchAuthenticatedUserSuccess(user));
  } catch (error) {
    yield put(
      enqueueSnackbar({
        message: error.data.message,
      })
    );
  }
}

export function* logout() {
  try {
    yield put(logoutSuccess());
    yield call(removeItem, 'token');
  } catch (error) {
    console.log(error);

    yield put(
      enqueueSnackbar({
        message: error.data.message,
      })
    );
  }
}

export function* fetchCommonData() {
  try {
    const commonData = yield call(request, {
      url: ENDPOINTS.COMMON_DATA,
      method: 'get',
    });
    yield put(fetchCommonDataSuccess(commonData));
  } catch (error) {
    console.error(error);

    yield put(
      enqueueSnackbar({
        message: error.data.message,
      })
    );
  }
}

export function* changeLocale({ locale }) {
  try {
    yield put(setLocale(locale));
    yield call(setItem, 'locale', locale);
  } catch (error) {
    console.error(error);

    yield put(
      enqueueSnackbar({
        message: error.data.message,
      })
    );
  }
}

export function* updateAuthenticatedUserFn({ payload }) {
  try {
    const user = yield call(request, {
      url: ENDPOINTS.UPDATE_AUTHENTICATED_USER,
      method: HTTP_METHODS.PUT,
      data: payload.user,
    });
    yield put(fetchAuthenticatedUserSuccess(user));
  } catch (error) {
    console.error(error);

    yield put(
      enqueueSnackbar({
        message: error.data.message,
      })
    );
  }
}

export default function* appSaga() {
  yield takeLatest(FETCH_AUTHENTICATED_USER_REQUEST, fetchUser);
  yield takeLatest(LOGOUT_REQUEST, logout);
  yield takeLatest(FETCH_COMMON_DATA_REQUEST, fetchCommonData);
  yield takeLatest(CHANGE_LOCALE_SAGA, changeLocale);
  yield takeLatest(UPDATE_AUTHENTICATED_USER, updateAuthenticatedUserFn);
}
